import { render, staticRenderFns } from "./LastUpdate.vue?vue&type=template&id=557ab232&scoped=true"
import script from "./LastUpdate.vue?vue&type=script&lang=js"
export * from "./LastUpdate.vue?vue&type=script&lang=js"
import style0 from "./LastUpdate.vue?vue&type=style&index=0&id=557ab232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ab232",
  null
  
)

export default component.exports